import { render } from "./no-items.vue?vue&type=template&id=03023b6a&scoped=true"
import script from "./no-items.vue?vue&type=script&lang=js"
export * from "./no-items.vue?vue&type=script&lang=js"

import "./no-items.vue?vue&type=style&index=0&id=03023b6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03023b6a"]])

export default __exports__